import React from 'react';
import { Icon, Reveal } from '@/components/ui';
import type { IconName } from '@/lib/icons';

interface QualityFactorProps {
    icon: IconName;
    title: string;
    description: string;
    /** Stagger delay (ms) for the scroll-reveal animation. */
    delay?: number;
}

const QualityFactor: React.FC<QualityFactorProps> = ({ icon, title, description, delay }) => {
    return (
        <Reveal as="div" className="trust-item" delay={delay}>
            <div className="icon-circle">
                <Icon name={icon} />
            </div>
            <h4>{title}</h4>
            <p>{description}</p>
        </Reveal>
    );
};

export default QualityFactor;
